import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

import { cookie } from 'ThreeTerminal_base/base';

/**
 * for this page
 */
import CheckBox from './checkBox';
import Radio from './radio';

import { postSurvey } from '../../../../../services/api';
import { loginAuthFunc } from '../../../utils/utils';

const isInArray = (value, arr) => {
    for (let i = 0; i < arr.length; i++) {
        if (value === arr[i]) {
            return true;
        }
    }

    return false;
};

const formatQuestionIds = data => {
    const res = [];

    data.forEach(item => {
        if (Number(item.resultArray.ismust)) {
            res.push(item.resultArray.questionid);
        }
    });

    return res;
};

class Form extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isLoginAuth: PropTypes.number,
    };

    state = {
        showData: false,
        error: false,
        errorItems: [], // 缓存错误的表单的id
        fieldsValue: {},
        fieldsIds: formatQuestionIds(this.props.content.result),
        disabled: false,

        element: null,
        enable: true,
        expire: !!Number(this.props.content.surveyinfo.expire),
    };

    tip = React.createRef();

    componentDidMount = () => {
        if (!this.state.expire) {
            this.setState({
                disabled: true,
                showData: true,
            });
        }
        this.setState({
            element: this.tip.current,
        });
    };

    // 提交
    handleSubmit = e => {
        e.preventDefault();

        const { content } = this.props;
        const { fieldsValue } = this.state;

        const isError = this.checkFields(fieldsValue);

        console.log(isError);
        if (isError) {
            this.showTip();
            this.setState({
                error: this.checkFields(fieldsValue),
            });
        } else {
            console.log(fieldsValue);
            console.log(this.formatParms(fieldsValue));
            this.asyncPostSurvey(content.surveyinfo.id, this.formatParms(fieldsValue));
        }
    };

    // 校验空
    checkFields = fieldsValue => {
        const { fieldsIds } = this.state;
        const { result } = this.props.content;
        const errorItems = [];

        // console.log(fieldsValue);

        if (fieldsValue && Object.keys(fieldsValue).length) {
            fieldsIds.forEach(item => {
                const value = fieldsValue[item];

                if (!value || (value && !value.length)) {
                    errorItems.push(item);
                }
            });

            this.setState({
                errorItems,
            });
        }
        // else {
        //     // 必选
        //     result.forEach(item => {
        //         const id = item.resultArray.questionid;

        //         if (Number(item.resultArray.ismust)) {
        //             errorItems.push(id);
        //         }
        //     });
        //     this.setState({
        //         errorItems,
        //     });
        // }

        if (errorItems.length) {
            return true;
        } else {
            return false;
        }
    };

    // 监听form变化
    handleChange = val => {
        const { fieldsValue } = this.state;
        const formItem = {};

        formItem[val.questionid] = val.value;
        this.setState({
            fieldsValue: { ...fieldsValue, ...formItem },
        });
    };

    // 格式化参数
    formatParms = values => {
        const res = [];

        for (const k in values) {
            if (values.hasOwnProperty(k)) {
                const item = values[k];

                item.forEach(i => {
                    const itemParams = `sur[${k}][]=${i}`;

                    res.push(itemParams);
                });
            }
        }

        return res.join('&');
    };

    // 发送提交请求
    asyncPostSurvey = async (id, sur) => {
        const { isLoginAuth } = this.props;

        let canPost = true;

        if (isLoginAuth) {
            canPost = loginAuthFunc();
        }

        let data = null;

        if (canPost) {
            data = await postSurvey(id, sur, isLoginAuth);
        }
        const { surveysetting } = this.props.content;

        if (data) {
            if (data.ifsuccess) {
                console.log('成功');
                const jumplink = surveysetting.jumplink;

                if (jumplink) {
                    window.location.href = jumplink;
                }
                this.setState({
                    disabled: true,
                    showData: true,
                });

                // if (surveysetting.limittime !== undefined) {
                //     cookie.set(
                //         `surveylimittime_${surveysetting.surid}`,
                //         '1',
                //         '/',
                //         '.ifeng.com',
                //         Number(surveysetting.limittime) * 3600 * 1000,
                //     );
                // }
            } else {
                alert(data.msg);
            }
        }
    };

    timer = null;
    // 显示调查数据
    showData = () => {
        if (
            !this.state.showData &&
            this.props.content &&
            this.props.content.surveysetting &&
            Number(this.props.content.surveysetting.isshow)
        ) {
            this.setState(
                {
                    showData: true,
                },
                () => {
                    this.showTip();
                },
            );
        }
    };

    showTip = () => {
        window.clearTimeout(this.timer);
        this.fadeIn(this.state.element, 30);
        this.timer = setTimeout(() => {
            this.fadeOut(this.state.element, 30);
        }, 3000);
    };

    // 淡入
    fadeIn = (element, speed) => {
        this.setState({
            enable: false,
        });
        if (element.style.opacity !== 1) {
            element.style.display = 'block';
            const _speed = speed || 30;
            let num = 0;
            const st = setInterval(() => {
                num++;
                element.style.opacity = num / 10;
                if (num >= 10) {
                    clearInterval(st);
                    this.setState({
                        enable: true,
                    });
                }
            }, _speed);
        }
    };

    // 淡出
    fadeOut = (element, speed) => {
        this.setState({
            enable: false,
        });
        if (element.style.opacity !== 0) {
            const _speed = speed || 30;
            let num = 10;
            const st = setInterval(() => {
                num--;
                element.style.opacity = num / 10;
                if (num <= 0) {
                    clearInterval(st);
                    setTimeout(() => {
                        element.style.display = 'none';
                        this.setState({
                            enable: true,
                        });
                    }, 300);
                }
            }, _speed);

            // console.log(st);
        }
    };
    render() {
        const { content } = this.props;
        const { result, surveysetting } = content;
        const { showData, error, errorItems, disabled } = this.state;

        const { expire } = content.surveyinfo; // 是否过期

        const hasSubmited = cookie.get(`surveylimittime_${surveysetting.surid}`);

        const form = (
            <form>
                {result &&
                    result.map((item, index) => {
                        if (item.resultArray.choosetype === 'multiple') {
                            return (
                                <CheckBox
                                    key={index}
                                    content={item.resultArray}
                                    onChange={this.handleChange}
                                    showData={showData && !!Number(content.surveysetting.isshow)}
                                    index={index}
                                    error={error && isInArray(item.resultArray.questionid, errorItems)}
                                    disabled={disabled}
                                />
                            );
                        } else {
                            return (
                                <Radio
                                    key={index}
                                    content={item.resultArray}
                                    onChange={this.handleChange}
                                    showData={showData && !!Number(content.surveysetting.isshow)}
                                    index={index}
                                    error={error && isInArray(item.resultArray.questionid, errorItems)}
                                    disabled={disabled}
                                />
                            );
                        }
                    })}
            </form>
        );

        const submitBtn = (
            <div className={styles.surresult}>
                {Number(content.surveysetting.isshow) ? (
                    <div className={styles.showData} onClick={this.showData}>
                        点击查看调查结果&gt;&gt;
                    </div>
                ) : null}

                {/* {disabled || hasSubmited ? (
                    <button className={styles.btn_d}>已提交</button>
                ) : ( */}
                <button className={styles.btn} onClick={this.handleSubmit}>
                    提交
                </button>
                {/* )} */}
            </div>
        );

        const tip = (
            <div className={styles.tips} ref={this.tip}>
                请选择您的观点，然后提交
            </div>
        );

        const expireDom = (
            <div>
                <strong style={{ fontWeight: 'bold' }}>{content.surveysetting.expinfo}</strong>
                截止时间：<span>{content.surveyinfo.endtime}</span>
            </div>
        );

        return (
            <div className={styles.form}>
                {form}
                {tip}
                {Number(content.surveyinfo.expire) ? submitBtn : expireDom}
            </div>
        );
    }
}

export default Form;
